 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		183: 0,
 		69: 0,
 		70: 0,
 		80: 0,
 		124: 0,
 		125: 0,
 		132: 0,
 		133: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","6":"AddClosedAlertIDUseCase","7":"CreateDeviceUseCase","8":"CreateDomestikaFollowUseCase","9":"CreateJWTUserUseCase","10":"CreateUserLiveSessionUseCase","11":"CurrentUserUseCase","12":"CurrentWithoutRelationshipsUserUseCase","13":"DeleteDeviceUseCase","14":"DeleteFollowUseCase","15":"ENV_CONFIG1","16":"ENV_CONFIG4","17":"ENV_CONFIG5","18":"ENV_CONFIG6","19":"ENV_CONFIG7","20":"FinishUserLiveSessionUseCase","21":"GetAccessTokenUserUseCase","22":"GetAdvanceGDPRStatusUserUseCase","23":"GetAllBlogUseCase","24":"GetAreasCourseUseCase","25":"GetCartCourseUseCase","26":"GetCategoriesCourseUseCase","27":"GetCourseUseCase","28":"GetFinalProjectVideoByCourseIDCourseUseCase","29":"GetGDPRStatusUserUseCase","30":"GetListLiveFeedbackQuestionUseCase","31":"GetListLiveSessionUseCase","32":"GetListLiveStreamUseCase","33":"GetLiveChannelUseCase","34":"GetLiveSessionUseCase","35":"GetOrganizationUseCase","36":"GetPlusPromotionUseCase","37":"GetPostContentBlogUseCase","38":"GetPromotionCodeAlertUseCase","39":"GetPromotionUseCase","40":"GetPubnubCredentialsUseCase","41":"GetSessionDataUserUseCase","42":"GetSimpleUserUseCase","43":"GetSoftwaresCourseUseCase","44":"GetUserAlertUseCase","45":"GetVideoProgressListCourseUseCase","46":"GetVideoSpeedUserUseCase","47":"GetVideoVolumeUserUseCase","48":"LogoutUserUseCase","49":"PathToRegexp","50":"RefreshAccessTokenUserUseCase","51":"RemoveAccessTokenUserUseCase","52":"SearchCourseUseCase","53":"SendHeaderTrackingUseCase","54":"SendLiveFeedbackAnswersUseCase","55":"SendPlayerTrackingUseCase","56":"SendTrackingUseCase","57":"SendVideoProgressCourseUseCase","58":"SetAdvanceGDPRStatusUserUseCase","59":"SetGDPRStatusUserUseCase","60":"SetVideoSpeedUserUseCase","61":"SetVideoVolumeUserUseCase","62":"UpdateLanguageUserUseCase","63":"UpdateLiveSessionUseCase","64":"UpdateVideoAudioAndSubtitlesCourseUseCase","65":"UpdateVideoProgressCourseUseCase","66":"ViewPageTrackingUseCase","134":"vendors~AddClosedAlertIDUseCase","135":"vendors~AlgoliaSearch","136":"vendors~AmplitudeJS","137":"vendors~SearchCourseUseCase","138":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"14f076f3863554d69e42","1":"319cd40f0b2bd3ca3316","2":"7a0506b04312caa802f7","3":"c08ca4fead37dbda77fd","4":"7072df3c8926fd41bede","5":"d827f1c724bbbbfcd83a","6":"3fa8a310d961e478161c","7":"12d16d504db12f7b730f","8":"683b6f3e24aef5905fe6","9":"496267af869d0f862320","10":"a1b7d04ac243bfc34ede","11":"03864f1e60798e0b2f59","12":"b2077b3835f43bd64fd1","13":"077c0947d829124054aa","14":"9df6ffcb0557e41260e6","15":"dbd292dd85d2e6f7bfee","16":"37b8acc9b2ac50135c8a","17":"65901d8cf1f9bdcf2d4c","18":"2c91ccaca74c2cca92aa","19":"dc3a519f0abbbe14d040","20":"cde2d19974166f8f78b9","21":"a43f8ec907ff8dd0fbea","22":"88e5f0755b3485991d3c","23":"ebbeede7ae4b4b10875a","24":"b8534f107baf26b2ae1e","25":"6abe8c2e77912c3609d7","26":"460f181b5b570d317db8","27":"a24a7e26f3f618808c27","28":"aae332a1ee9a49a18a48","29":"23c42e7b4f89df10aee1","30":"0ca548eb46ed557a456d","31":"35bbad3c498cc0a968b6","32":"c2cf6fbd875680a8a9b5","33":"f946f9c887320b3044c6","34":"e87805f370306a3acce6","35":"02025247b987a825d207","36":"e54275ad007ddfbb7f9c","37":"38081af7b9ee13bf8758","38":"6a3c5d9045343f026979","39":"0cf4ebdc7f7aeb7e3d79","40":"f50ec74962e571e15cf8","41":"659b0ee72e9f3f5e62ce","42":"756e0b74a2e6129d88cb","43":"f2817103ee257a3d86af","44":"71123b90fe25f23aaf82","45":"fcd9a0c384ffff86eaca","46":"efba15f676701424ce1b","47":"b9e26ab5769df8764eaa","48":"82dc1cd1c9982409a245","49":"e61ac790ba6abc419a7a","50":"27594ee82da84653ccda","51":"9458d55034ab1df62732","52":"19e8aaa3e6e9563ceb96","53":"a6cc56b0e7e2b288d90a","54":"b4b8d7eed974d3988652","55":"2a7dce77bab62bf651c8","56":"11bdb2285abb67a50b09","57":"3d79c8bab39b05bd4de9","58":"275cabd21eb7933f4a26","59":"c1037d9513b2f5c7ad90","60":"36fd88beafa90d085cea","61":"8a7cd38c0d18ce04f1fa","62":"f209512af732e4133161","63":"fc5593aca232db28d1d1","64":"bd04678743c9f0a88281","65":"932ef57ea89c8aa0f087","66":"687e81f9ab9ed3bf2e36","134":"edf64a559ef5d1436197","135":"a8d6f6070ec778a287a7","136":"12d9130dacf7e6b99eb2","137":"39b9bbef30212d61a080","138":"9fc67d9347fa69468ac7","201":"92add364527d7a1186dd","203":"fe8c538b1629ae84f674","204":"0354cd60cf3211b70f56","205":"2d27fd47040e6098e375","206":"9a993bb43cb979c6340b"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 488);
